import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { DocumentManagementSettingsComponent } from './document-management-settings-page.component';

/**
 * Registers the document-management settings page in the global settings sidebar at
 * `/settings/document-management`. The guard uses the dedicated document-management settings
 * resource, matching the backend's `documents.settings.update` mutation grant.
 *
 * `entitlementFeatureKey: 'document-management'` opts the entry into the shared plan-required
 * machinery: tenants whose plan no longer entitles the feature get the lock badge in the sidebar
 * and clicking through routes to `/settings/plan-required/document-management` instead of the
 * regular settings page (whose backend `GET /settings` would return 403 anyway).
 */
export function provideSettingsElementDocumentManagement(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'document-management',
        name: 'Document management',
        icon: 'pi pi-file',
        component: DocumentManagementSettingsComponent,
        order: 4,
        translateName: 'DOCUMENT_MANAGEMENT.SETTINGS.TITLE',
        resource_key: 'documentManagementSettings',
        required_action: 'update',
        canActivate: [ResourceAccessGuard],
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'document-management',
        category: {
          id: 'workspace',
          name: 'Workspace',
          order: 1,
          translateName: 'SETTINGS.CATEGORIES.WORKSPACE',
        },
      },
      multi: true,
    },
  ]);
}
